import React from 'react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Download, Calendar } from 'lucide-react';
interface LloydCardProps {
  title: string;
  subtitle: string;
  description: string;
  imageSrc: string;
  url: string;
  buttonText?: string;
  buttonIcon?: 'download' | 'calendar';
  badge?: string;
  onButtonClick?: () => void;
}
export function LloydCard({
  title,
  subtitle,
  description,
  imageSrc,
  url,
  buttonText = 'Descargar este Lloyd',
  buttonIcon = 'download',
  badge,
  onButtonClick
}: LloydCardProps) {
  const icon = buttonIcon === 'download' ? <Download className="w-4 h-4 flex-shrink-0" data-id="element-338" /> : <Calendar className="w-4 h-4 flex-shrink-0" data-id="element-339" />;
  const handleClick = () => {
    if (onButtonClick) {
      onButtonClick();
    }
  };
  return <Card hoverEffect className="h-full flex flex-col" data-id="element-340">
      <div className="h-48 relative overflow-hidden bg-slate-900" data-id="element-341">
        <img src={imageSrc} alt={title} className="w-full h-full object-cover" data-id="element-342" />
        {badge && <div className="absolute top-2 left-2 right-2 z-10 bg-red-600 text-white px-2 py-1.5 rounded-lg text-[10px] md:text-xs font-bold text-center shadow-lg" data-id="element-343">
            {badge}
          </div>}
        <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-white to-transparent" data-id="element-344" />
      </div>
      <div className="p-6 flex-grow flex flex-col" data-id="element-345">
        <div className="mb-4" data-id="element-346">
          <h3 className="text-xl font-bold text-slate-900" data-id="element-347">{title}</h3>
          <p className="text-sm font-medium text-teal-600 mt-1" data-id="element-348">{subtitle}</p>
        </div>
        <p className="text-slate-600 mb-6 flex-grow text-sm leading-relaxed" data-id="element-349">
          {description}
        </p>
        <a href={url} target="_blank" rel="noopener noreferrer" className="block" onClick={handleClick} data-id="element-350">
          <Button variant="outlineCyan" className="w-full h-auto min-h-[48px] py-3 px-4" leftIcon={icon} data-id="element-351">
            <span className="text-sm font-semibold leading-snug whitespace-normal break-words" data-id="element-352">
              {buttonText}
            </span>
          </Button>
        </a>
      </div>
    </Card>;
}